import { motion, useInView } from 'framer-motion';
import { useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { NeonText } from '../../effects';
import { ModelViewer } from '../../common';
import { useLanguage } from '@/i18n';
import { models } from '@/data';
import styles from './Playground.module.css';

const MOBILE_BREAKPOINT = 768;

export function Playground() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });
  const [isMobile, setIsMobile] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <section id="playground" className={styles.playground} ref={ref}>
      <div className={styles.container}>
        <motion.div
          className={styles.header}
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <NeonText as="h2" color="cyan" effect="glow" className={styles.title} animate={false}>
            {t.playground.title}
          </NeonText>
          <p className={styles.subtitle}>
            {t.playground.subtitle}
          </p>
        </motion.div>

        <motion.div
          className={styles.viewerWrapper}
          initial={{ opacity: 0, scale: 0.95 }}
          animate={isInView ? { opacity: 1, scale: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {isMobile ? (
            <div className={styles.modelViewerWrapper}>
              <ModelViewer
                models={models}
                variant="compact"
                autoRotate={true}
                showControls={true}
                showInfo={false}
                showToolbar={false}
              />
            </div>
          ) : (
            <div className={styles.iframeWrapper}>
              <iframe
                src="/UnityWebGl/HausFIg_RenderCreator_ALTEA/index.html"
                title="Render Creator - Configurador de Baños"
                className={styles.iframe}
                allow="fullscreen"
                scrolling="no"
              />
            </div>
          )}
        </motion.div>

        <motion.div
          className={styles.cta}
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ delay: 0.6 }}
        >
          <Link to="/playground" className={styles.ctaLink}>
            {t.playground.viewMore}
            <span className={styles.arrow}>→</span>
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
